import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IPaginatedResponse } from '../../interfaces/api/responses.interface';

@Injectable({
  providedIn: 'root',
})
export class ContractService {
  private apiUrlContract = `${environment.apiUrl}/contracts`;

  constructor(private http: HttpClient) {}

  getContractByContractId(idContract: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrlContract}/${idContract}`);
  }

  updateChangeStateContract(
    idContract: number,
    data: FormData
  ): Observable<any> {
    return this.http.put<any>(
      `${this.apiUrlContract}/changeStateContract/${idContract}`,
      data
    );
  }

  updateContract(id: number, data: FormData): Observable<any> {
    return this.http.put<any>(`${this.apiUrlContract}/${id}`, data);
  }

  getContractDetailByEmployeeId(employeeId: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrlContract}/detail/${employeeId}`);
  }

  postContractHistoryByEmployeeId(
    employeeId: number,
    filters: Record<string, unknown>
  ): Observable<IPaginatedResponse<any>> {
    return this.http.post<IPaginatedResponse<any>>(
      `${this.apiUrlContract}/history/${employeeId}`, 
      filters
    );
  }
}
